import styled from '@emotion/styled'

import { Color } from '../constants/color'
import { StyleProps, createStyles } from '../utils'
import {
  ColorProps,
  OpacityProps,
  SpaceProps,
  opacity,
  space,
} from '../utils/styled-system'

export type HorizontalRuleProps = ColorProps &
  OpacityProps &
  SpaceProps & {
    padded?: boolean
    styles?: StyleProps
  }

export const HorizontalRule = styled.hr((props: HorizontalRuleProps) => ({
  ...opacity(props),
  border: 'none',
  borderTop: `1px solid ${props.color ?? Color.GREY}`,
  height: 0,
  margin: 0,
  paddingBottom: props.padded ? 32 : undefined,
  paddingTop: props.padded ? 32 : undefined,
  width: '100%',
  ...space(props),
  ...createStyles(props.styles),
}))
